import { create } from 'zustand';

type SubscriptionNotificationStore = {
  showNotification: boolean;
  setShowNotification: (shouldShow: boolean) => void;
};

export const useSubscriptionNotificationStore =
  create<SubscriptionNotificationStore>(set => ({
    showNotification: false,
    setShowNotification: shouldShow => {
      set({ showNotification: shouldShow });
    },
  }));
